import { IApplicationState } from '../../types/redux';

export function getReportState(state: IApplicationState) {
  return state.report;
}
